import { retrivePageType } from 'services/analytics/page_type'

const initialState = {
  referrer_page: retrivePageType(),
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case 'INVITEE_LANDED':
      return {
        ...state,
        invitee_landed_at: payload.timestamp
      }
    case 'INVITEE_SET_FROM':
      return {
        ...state,
        from: payload.from
      }
    case 'SET_REFERRER_PAGE':
      return {
        ...state,
        referrer_page: payload.referrerPage
      }
    case 'SET_ANALYTICS_BOOKING_METHOD':
      return {
        ...state,
        booking_method: payload.bookingMethod,
      }
    default:
      return state
  }
}
